<template>
  <BaseButton primary @click="openNewEmailCampaignDialog"> New Email Campaign </BaseButton>
</template>

<script>
import { projectEmailCampaignsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
  methods: {
    submit(data) {
      return projectEmailCampaignsClient.store(this.projectId, data).then((response) => {
        this.$emit('created');
        this.openEditEmailCampaignDialog(response.data);
        return Promise.resolve(response);
      });
    },
    openNewEmailCampaignDialog() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/EmailCampaign/CreateEmailCampaignDialog/CreateEmailCampaignDialog.vue'
          ),
        props: {
          accountId: this.accountId,
          action: this.submit,
        },
        on: {},
        hideEvent: 'close',
      });
    },
    openEditEmailCampaignDialog(emailCampaign) {
      this.$modal.show({
        component: () =>
          import('@/components/EmailCampaign/EditEmailCampaignDialog/EditEmailCampaignDialog.vue'),
        props: {
          emailCampaignId: emailCampaign.id,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
